<template>
    <div class="row">
        <div class="col-12">
            <div class="table-responsive mb-0">
                <table class="table table-bordered table-sm mb-0">
                    <thead>
                        <tr>
                            <th class="text-nowrap">Taksit</th>
                            <th class="text-nowrap">Durum</th>
                            <th class="text-nowrap">Ödenecek Dönem</th>
                            <th class="text-nowrap">Ödeme Tarihi</th>
                            <th class="text-nowrap text-right">Ödenen Tutar (TL)</th>
                            <th class="text-nowrap text-right">Kalan Tutar (TL)</th>
                            <th class="text-nowrap text-right">Toplam Tutar (TL)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ins,i) in (value.IncidentInstallments || [])" :key="i">
                            <td>{{$safe(ins,'InstallmentOrder')}}</td>
                            <td>
                                <b-badge :variant="getStatus(ins)">
                                    {{$safe(ins,'PaymentStatusStr')}}
                                </b-badge>
                            </td>
                            <td>{{$safe(ins,'ExpectedPeriod')}}</td>
                            <td>{{$safe(ins,'PaidDateStr') || '-'}}</td>
                            <td class="text-right">{{$safe(ins,'PaidAmountStr')}}</td>
                            <td class="text-right">{{$safe(ins,'RemainingAmountStr')}}</td>
                            <td class="text-right">{{$safe(ins,'TotalAmountStr')}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import {BBadge} from 'bootstrap-vue'

export default {
    components:{
        BBadge
    },
    props:{
        value:Object
    },
    methods:{
        getStatus(ins){
            switch (this.$safe(ins,'PaymentStatus')) {
                case 0: return 'success'
                case 1: return 'warning'
                case 2: return 'danger'
                default: return 'dark'
            }
        }
    }
}
</script>

<style>

</style>